module.exports = __webpack_public_path__ + "static/media/spin_gold.dd631045.png";